/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Forward_Five_FramesInputs */

const en_shortcut_keys_name_forward_five_frames = /** @type {(inputs: Shortcut_Keys_Name_Forward_Five_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forward 5 Frame`)
};

const fr_shortcut_keys_name_forward_five_frames = /** @type {(inputs: Shortcut_Keys_Name_Forward_Five_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avancer de 5 images`)
};

const de_shortcut_keys_name_forward_five_frames = /** @type {(inputs: Shortcut_Keys_Name_Forward_Five_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorwärts 5 Frame`)
};

const it_shortcut_keys_name_forward_five_frames = /** @type {(inputs: Shortcut_Keys_Name_Forward_Five_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avanti 5 fotogrammi`)
};

const ru_shortcut_keys_name_forward_five_frames = /** @type {(inputs: Shortcut_Keys_Name_Forward_Five_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вперед 5 кадров`)
};

const es_shortcut_keys_name_forward_five_frames = /** @type {(inputs: Shortcut_Keys_Name_Forward_Five_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avanzar 5 cuadros`)
};

const zh_cn2_shortcut_keys_name_forward_five_frames = /** @type {(inputs: Shortcut_Keys_Name_Forward_Five_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前进 5 帧`)
};

const ja_shortcut_keys_name_forward_five_frames = /** @type {(inputs: Shortcut_Keys_Name_Forward_Five_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5フレーム進む`)
};

const hi_shortcut_keys_name_forward_five_frames = /** @type {(inputs: Shortcut_Keys_Name_Forward_Five_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आगे 5 फ्रेम`)
};

const pt_pt2_shortcut_keys_name_forward_five_frames = /** @type {(inputs: Shortcut_Keys_Name_Forward_Five_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quadro 5 para frente`)
};

/**
* | output |
* | --- |
* | "Forward 5 Frame" |
*
* @param {Shortcut_Keys_Name_Forward_Five_FramesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_forward_five_frames = /** @type {((inputs?: Shortcut_Keys_Name_Forward_Five_FramesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Forward_Five_FramesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_forward_five_frames(inputs)
	if (locale === "de") return de_shortcut_keys_name_forward_five_frames(inputs)
	if (locale === "it") return it_shortcut_keys_name_forward_five_frames(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_forward_five_frames(inputs)
	if (locale === "es") return es_shortcut_keys_name_forward_five_frames(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_forward_five_frames(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_forward_five_frames(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_forward_five_frames(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_forward_five_frames(inputs)
	return en_shortcut_keys_name_forward_five_frames(inputs)
});